import Package from "@/ts/interfaces/Package";

export default {
    state: {
        dialogVisible: false,
        servesSelect: false,
        order_index: 0,
        package: {},
        name: ""
    },
    show() {
        this.state.dialogVisible = true;
        this.state.servesSelect = true;
    },
    showEdit(item: Package) {
        this.state.dialogVisible = true;
        this.state.order_index = item.order_index;
        this.state.package = item;
    },
    dismiss() {
        this.state.dialogVisible = false;
        this.state.servesSelect = false;
        this.state.order_index = 0;
        this.state.package = {};
        this.state.name = "";
    }
}
